/* eslint-disable @next/next/no-img-element */
import useCommon from '@utils/hooks/common';
import styles from './styles';

export type PropsType = {
  cardName: string;
  backgroundPath: string;
  image: JSX.Element;
  handleClick: any;
  id?: string; // For bot to click
  content?: string;
};

const HomeCardItem = (props: PropsType) => {
  const {cardName, backgroundPath, image, handleClick, id, content} = props;
  const {classes} = useCommon({
    withStyles: styles,
  });

  return (
    <div className={classes.cardContainer} onClick={handleClick} id={id}>
      <div className={classes.imageContainer}>{image}</div>
      <div className={classes.textContainer}>
        <span className={classes.cardTitle}>{cardName}</span>
        <span className={classes.cardContent}>{content}</span>
      </div>
    </div>
  );
};

export default HomeCardItem;
